import { coreDealInformation } from '../fields.config';
import GenericFormSection from '../GenericFormSection/GenericFormSection';
import Services from '../Services';

export const sections = [
  { title: `Core Deal Information`, fields: coreDealInformation, Component: GenericFormSection },
  { title: `Services`, Component: Services },
];
